import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import PageHeader from "./-components/PageHeader";
import ConsoleHrozontalHeadTable, { DataListProps } from "./-components/ConsolehorizontalHeadTable";
import LoadingPop from "components/popup/LoadingPop";
import { RouteTypes, toastErrorSyle } from "hooks/utils/util";
import { useDeleteConsoleTrackingSupplies } from "hooks/console/useDeleteConsoleTrackingSupplies";
import { useGetConsoleTrackingSuppliesDetail } from "hooks/console/useGetConsoleTrackingSuppliesDetail";
import { usePutConsoleTrackingSupplies } from "hooks/console/usePutConsoleTrackingSupplies";
import { TrackingSuppliesFormProps } from "./common/TrackingSuppliesForm";
import Comment from "./-components/Comment";
import { usePostConsoleWaybillComment } from "hooks/console/usePostConsoleWaybillComment";
import { usePutConsoleWaybillComment } from "hooks/console/usePutConsoleWaybillComment";
import { useDeleteConsoleWaybillComment } from "hooks/console/useDeleteConsoleWaybillComment";
import { ReactComponent as ArrowDown } from "assets/morning/icon/arrowDownNavy.svg";
import ConfirmDialog from "components/popup/ConfirmDialog";
import Seo from "components/Seo";
import { format } from "date-fns";
import PrintColor from "../morning/-components/PrintColor";

const initialForm = {
    result: null,
    category: "",
    flag: true,
    list_no: null,
    bl_no: "",
    subject: "",
    contents: "",
    company: "",
    m_email: "",
    mobile: "",
    w_date: "",
    comment: [
        // {
        //     c_list_no: 1,
        //     c_content: "코멘트입니다.",
        // },
    ],
};
export default function ConsoleTrackingSuppliesDetail({ type }: { type: RouteTypes }) {
    const navigate = useNavigate();
    const params = useParams();
    const idx = params.idx;
    const [form, setForm] = useState<TrackingSuppliesFormProps>(initialForm);
    const [printData, setPrintData] = useState<Record<string, string>[] | null>(null);
    const [memo, setMemo] = useState("");
    const { data, isLoading, refetch: refetchDetail } = useGetConsoleTrackingSuppliesDetail({ category: type, list_no: idx ?? "" });
    const { mutate: updateSupplies } = usePutConsoleTrackingSupplies();
    const { mutate: deleteSupplies } = useDeleteConsoleTrackingSupplies();

    const { mutate: postComment } = usePostConsoleWaybillComment();
    const { mutate: updateComment } = usePutConsoleWaybillComment();
    const { mutate: deleteComment } = useDeleteConsoleWaybillComment();

    useEffect(() => {
        if (data) {
            setForm({
                category: type,
                result: data.result,
                flag: data.flag,
                list_no: data.list_no,
                bl_no: data.bl_no,
                subject: data.subject,
                contents: data.contents,
                company: data.company,
                m_email: data.m_email,
                mobile: data.mobile,
                w_date: data.w_date,
                comment: data.comment,
            });
            setMemo(data.memo ?? "");
        }
    }, [data, type]);

    const thead = [
        {
            title: "처리상태",
            key: "result",
            content: (value: number) => (
                <Select value={form.result?.toString()} onValueChange={value => handleChangeRowStatus(value)}>
                    <SelectTrigger
                        className={`relative text-[#1B1C1E] text-[16px] flex gap-[10px] rounded-[5px] focus:ring-2  border-none shadow-none max-w-[100px] justify-center ${value === 2 ? "text-[#4F46E5]" : "text-[#999999]"}`}
                    >
                        <SelectValue placeholder="" />
                        <ArrowDown className="[&_path]:fill-[#1C1B1F]" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                        <SelectItem value="1">접수대기</SelectItem>
                        <SelectItem value="2">처리완료</SelectItem>
                    </SelectContent>
                </Select>
            ),
        },
        { title: "신청일", key: "w_date", tdClassName: "px-5" },
        {
            title: "요청업체명",
            key: "name",
            thClassName: "whitespace-nowrap",
            tdClassName: "px-5",
            content: (value: string, data: DataListProps) => (
                <div className="flex items-center gap-x-1">
                    <span>{value}</span>
                    {data?.is_app && <span className="shrink-0 rounded-[4px] bg-[#4F46E5] px-[6px] py-[1px] text-[12px] text-white">모바일</span>}
                </div>
            ),
        },
        {
            title: "대표자",
            key: "boss",
            thClassName: "whitespace-nowrap",
            tdClassName: "px-5",
            content: (value: string) => <span>{value}</span>,
        },

        { title: "전화번호", key: "mobile", tdClassName: "px-5" },
        { title: "주소", key: "address", tdClassName: "px-5" },
        {
            title: "요청사항",
            key: "printer",
            tdClassName: "px-5",
            content: (value: string, data: DataListProps) => {
                const { printer, label, printerLabel, invoice, bag } = data;
                const displayItems = [printer, label, printerLabel, invoice, bag].filter(item => item?.trim()).join(", ");
                return <span>{displayItems}</span>;
            },
        },
        {
            title: "내용",
            key: "contents",
            content: (value: string) => <div className="py-3 px-3" dangerouslySetInnerHTML={{ __html: value }} />,
        },
        {
            title: "메모",
            key: "memo",
            content: () => (
                <div className="flex gap-2 py-3 px-3">
                    <textarea
                        name="memo"
                        value={memo}
                        onChange={e => setMemo(e.target.value)}
                        placeholder="메모를 입력해주세요."
                        className="flex-1 border border-[#dddddd] rounded-[8px] p-3 min-h-[100px] text-[#1B1C1E] resize-y"
                    />
                    <button
                        type="button"
                        onClick={handleSaveMemo}
                        className="shrink-0 self-end text-white text-[14px] bg-[#4F46E5] rounded-[5px] px-[20px] py-[10px]"
                    >
                        저장
                    </button>
                </div>
            ),
        },
    ];

    const handleDeleteSupplies = () => {
        if (data) {
            deleteSupplies(
                { category: type, list_no: [data.list_no] },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 삭제 되었습니다.");
                        navigate(-1);
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };

    // 컬러 라벨 프린터 출력 (고객 운송장 출력과 동일 레이아웃, 받는 쪽은 신청 업체)
    const handlePrint = () => {
        if (!data) return;
        const { name, boss, mobile, address: rawAddress } = data as typeof data & { name?: string; address?: string };
        // 주소 앞에 붙은 우편번호(5자리)는 출력하지 않음
        const address = (rawAddress ?? "").replace(/^\s*[[(]?\d{5}[\])]?\s*/, "");
        setPrintData([
            {
                // 지점(센터코드/센터명)·픽업담당(담당자명)은 비워서 출력, 요청사항 칸에는 메모 출력
                접수일자: format(new Date(), "yyyyMMdd"),
                담당자명: "",
                요청사항: data.memo ?? "",
                수량: "1-1",
                보내는상호: "(주)일신모닝택배",
                보내는전화번호: "1566-0685",
                보내는주소1: "경기도 고양시 덕양구 행주산성로 214 (행주외동) 일신빌딩",
                받는상호: name ?? "",
                받는전화번호: mobile ?? "",
                // 신청 건에는 담당자 정보가 없어 업체 대표자를 주소 뒤에 붙여 출력 (앱(모바일) 신청은 주소만)
                받는주소1: data.is_app ? address : [address, boss].filter(Boolean).join(" "),
            },
        ]);
    };

    function handleChangeRowStatus(value: string) {
        if (form.list_no) {
            updateSupplies(
                {
                    category: type,
                    list_no: form.list_no?.toString(),
                    result: Number(value),
                },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 수정 되었습니다.");
                        refetchDetail();
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    }

    // 메모 저장
    const handleSaveMemo = () => {
        if (form.list_no) {
            updateSupplies(
                {
                    category: type,
                    list_no: form.list_no.toString(),
                    memo,
                },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 저장 되었습니다.");
                        refetchDetail();
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };

    // 코멘트 등록
    const handlePostComment = (value: string, successCallback: () => void) => {
        if (idx) {
            postComment(
                {
                    category: type,
                    list_no: idx,
                    c_content: value,
                },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 등록 되었습니다.");
                        refetchDetail();
                        successCallback();
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };
    // 코멘트 수정
    const handleUpdateComment = (cListNo: string, content: string) => {
        if (idx) {
            updateComment(
                {
                    category: type,
                    list_no: idx,
                    c_list_no: cListNo,
                    c_content: content,
                },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 수정 되었습니다.");
                        refetchDetail();
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };
    // 코멘트 삭제
    const handleDeleteComment = (cListNo: string) => {
        if (idx) {
            deleteComment(
                {
                    category: type,
                    list_no: idx,
                    c_list_no: cListNo,
                },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 삭제 되었습니다.");
                        refetchDetail();
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };

    return (
        <>
            <Seo type="console" pageTitle="운송장 신청접수" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="운송장 신청접수" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className=" px-[40px] py-[28px] w-full overflow-auto">
                        {isLoading ? (
                            <LoadingPop />
                        ) : (
                            <div className="bg-white rounded-[20px] py-[36px] px-[40px] w-full min-w-[800px]">
                                {data ? (
                                    <>
                                        <ConsoleHrozontalHeadTable thead={thead} tbody={data} />
                                        <div className="flex justify-center gap-x-[8px] mt-5">
                                            <ConfirmDialog
                                                title="접수 삭제"
                                                trigger={open => (
                                                    <button
                                                        type="button"
                                                        onClick={open}
                                                        className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                    >
                                                        삭제
                                                    </button>
                                                )}
                                                handleConfirm={handleDeleteSupplies}
                                            />
                                            <button
                                                type="button"
                                                onClick={handlePrint}
                                                className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                            >
                                                프린트
                                            </button>
                                            <button
                                                onClick={() => navigate(-1)}
                                                className="text-white text-[18px] bg-[#4F46E5] rounded-[5px] border border-[#666666] px-[55px] py-[15px]"
                                            >
                                                목록
                                            </button>
                                        </div>

                                        <Comment
                                            commentData={form.comment}
                                            postComment={handlePostComment}
                                            updateComment={handleUpdateComment}
                                            deleteComment={handleDeleteComment}
                                        />
                                    </>
                                ) : (
                                    <div className="flex flex-col gap-5 items-center justify-center py-[100px]">
                                        <p>결과가 없습니다.</p>
                                        <button onClick={() => navigate(-1)} className="rounded-[8px] border px-5 py-2">
                                            뒤로가기
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {printData && <PrintColor data={printData} hideQr onClose={() => setPrintData(null)} />}
            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
}
